import * as React from 'react';
import { useState } from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  Button,
  Typography,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import CreateButtonWithModal from '../components/common/CreateButtonWithModal';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import EditModal from '../components/common/EditModal';
import Tooltip from '../components/common/Tooltip';
import ViewModal from '../components/common/ViewModal';

interface Column {
  id: keyof Data | 'action';
  label: string;
  minWidth?: number;
  align?: 'right' | 'center' | 'left';
}

const columns: readonly Column[] = [
  { id: 'staff id', label: 'Staff Id', minWidth: 150 },
  { id: 'email id', label: 'Email Id', minWidth: 100 },
  { id: 'first name', label: 'First Name', minWidth: 100 },
  { id: 'last name', label: 'Last Name', minWidth: 150 },
  { id: 'country', label: 'Country', minWidth: 120 },
  { id: 'reporting', label: 'Reporting', minWidth: 120 },
  { id: 'action', label: 'Action', minWidth: 120, align: 'center' },
];

interface Data {
  'staff id': string;
  'email id': string;
  'first name': string;
  'last name': string;
  country: string;
  reporting: string;
}

function createData(
  staffid: string,
  emailid: string,
  firstname: string,
  lastname: string,
  country: string,
  reporting: string
): Data {
  return { 
    'staff id': staffid,
    'email id': emailid,
    'first name': firstname,
    'last name': lastname,
   country,
    reporting,
   };
}

const initialRows: Data[] = [
  createData('S001', 'raj@example.com', 'Raj', 'Kumar', 'India', 'Admin'),
  createData('S002', 'john.doe@example.com', 'John', 'Doe', 'USA', 'Emma'),
  createData('S003', 'emma.smith@example.co.uk', 'Emma', 'Smith', 'United Kingdom', 'Raj'),
  createData('S004', 'satoshi@example.jp', 'Satoshi', 'Tanaka', 'Japan', 'John'),
];

const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProp = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
    anchorOrigin: {
      vertical: 'bottom' as 'bottom',
      horizontal: 'left' as 'left',
    },
    transformOrigin: {
      vertical: 'top' as 'top',
      horizontal: 'left' as 'left',
    },
    getContentAnchorEl: null, // Important for older versions of MUI v4; can omit for MUI v5+
  };

const label = [
  'Name',
  'Code',
  'Currency',
  'Continents'
];

const Users = () => {
  const [rows, setRows] = useState<Data[]>(initialRows);
  const [editOpen, setEditOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterBy, setFilterBy] = useState('');

  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSearch = () => {
    console.log(`Searching for "${searchTerm}" by ${filterBy}`);
  };

  const handleEditSave = (updatedData: Data) => {
    if (selectedRowIndex === null) return;
    const updatedRows = [...rows];
    updatedRows[selectedRowIndex] = updatedData;
    setRows(updatedRows);
    setEditOpen(false);
  };


  const handleDeleteRow = (staffId: string) => {
    const updatedRows = rows.filter((row) => row['staff id'] !== staffId);
    setRows(updatedRows);
    console.log(`Deleted row with staff id: ${staffId}`);
  };
  
  const renderActions = (row: Data, index: number) => (
    <>
      <IconButton
        color="primary"
        size="small"
        onClick={() => {
          setSelectedRowIndex(index);
          setEditOpen(true);
        }}
      >
        <EditIcon />
      </IconButton>
      <IconButton
        color="primary"
        size="small"
        onClick={() => {
          setSelectedRowIndex(index);
          setViewOpen(true);
        }}
      >
        <RemoveRedEyeIcon />
      </IconButton>
      
    </>
  );
  
    const [age, setAge] = React.useState('');
  
    const handleChange = (event: SelectChangeEvent) => {
      setAge(event.target.value);
    };

    const [labelName, setLabelName] = React.useState<string[]>([]);
        
          const labelChange = (event: SelectChangeEvent<typeof labelName>) => {
            const {
              target: { value },
            } = event;
            setLabelName(
              // On autofill we get a stringified value.
              typeof value === 'string' ? value.split(',') : value,
            );
          };

  return (
    <>
       <Box className="headingBtnWrap">
       <Typography variant="h1">Users</Typography>
              <CreateButtonWithModal buttonLabel="Create User" modalTitle="Create User">
                 <Box className="modalFormWrap">
              <Box component="form" className="modalForm">
                  <div className="form-control inputFieldWrap">
                      <label>Staff Id</label>
                      <input type="text" className='inputField' />
                  </div>
                  <div className="form-control inputFieldWrap">
                      <label>Email Id</label>
                      <input type="text" className='inputField' />
                  </div>
                  <div className="form-control inputFieldWrap">
                      <label>First Name</label>
                      <input type="text" className='inputField' />
                  </div>
                  <div className="form-control inputFieldWrap">
                      <label>Last Name</label>
                      <input type="text" className='inputField' />
                  </div>
                  <div className="form-control inputFieldWrap">
                      <label>Country</label>
                      <input type="text" className='inputField' />
                  </div>
                  <div className="form-control inputFieldWrap">
                      <label>Reporting</label>
                      <input type="text" className='inputField' />
                  </div>
              </Box>
              <Box display="flex" justifyContent="flex-end">
                  <Button variant="contained" className='formBtn'>Save</Button>
                  </Box>
                  </Box>
            </CreateButtonWithModal>
            </Box>
            
      <Paper sx={{ width: '100%', overflowX: 'auto', marginTop: '20px' }}>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align || 'left'}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
                <TableCell sx={{ minWidth: 100 }} align="center">Audit Trail</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, rowIndex) => (
                  <TableRow hover key={rowIndex}>
                                      {columns.map((column) => {
                                        const value = row[column.id as keyof Data];
                                        if (column.id === 'action') {
                                          return (
                                            <TableCell key={column.id} align="center">
                                              {renderActions(row, rowIndex)}
                                            </TableCell>
                                          );
                                        }
                                        
                                        
                                        return <TableCell key={column.id}>{value}</TableCell>;
                                      })}
                                      <TableCell align="center">
                                                          <Tooltip />
                                                        </TableCell>
                                    </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
      </Paper>

      {/* Edit Modal */}
              {selectedRowIndex !== null && (
                <EditModal
                  open={editOpen}
                  onClose={() => setEditOpen(false)}
                  initialData={rows[selectedRowIndex]}
                  onSave={handleEditSave}
                  excludeFields={['action', 'status']}
                  readOnlyFields={['createdBy']}
                  title="Edit User"
                />
              )}
              {selectedRowIndex !== null && (
  <ViewModal
    open={viewOpen}
    onClose={() => setViewOpen(false)}
    initialData={rows[selectedRowIndex]}
    title="View Role"
  />
)}
    </>
  );
};

export default Users;

